import {
  mdiHomeVariantOutline,
  mdiAccountFilterOutline,
  mdiFolderOutline,
  mdiLinkBoxOutline,
  mdiPencil,
} from "@mdi/js";
import { SideBarMenu } from "../types/SidebarMenu";
import { IProps as SidebarContentProps } from "../components/SidebarContent/IProps";
import { UserMenuLink } from "../components/UserNavMenu/type";

const getSectionIcon = (sectionName: string): string => {
  switch (sectionName.toUpperCase()) {
    case "GENERAL":
      return mdiHomeVariantOutline;
    case "LEAD DETAIL":
      return mdiAccountFilterOutline;
    case "REPORTS":
      return mdiFolderOutline;
    default:
      return mdiLinkBoxOutline;
  }
};

const getUserNavIcon = (title: string) => {
  switch (title) {
    case "General":
      return mdiHomeVariantOutline;
    case "Lead Detail":
      return mdiAccountFilterOutline;
    case "Marketing":
      return mdiFolderOutline;
    case "Edit Profile":
      return mdiPencil;
    default:
      return mdiLinkBoxOutline;
  }
};

export const mapMenuToUserNavContent = (
  menuItems: SideBarMenu[]
): UserMenuLink[] => {
  const visibleItems = menuItems
    .filter((item) => item.show !== "L")
    .sort((a, b) => a.groupNum - b.groupNum);

  const results: UserMenuLink[] = [];

  visibleItems.forEach((item) => {
    results.push({
      href: item.slug,
      label: item.title,
      Icon: getUserNavIcon(item.title),
    });
  });

  return results;
};

export const mapMenuToSidebarContent = (
  menuItems: SideBarMenu[]
): SidebarContentProps[] => {
  const visibleItems = menuItems
    .filter((item) => item.show !== "U")
    .sort((a, b) => a.groupNum - b.groupNum);

  const result: SidebarContentProps[] = [];
  const usedSections: string[] = [];

  visibleItems.forEach((item) => {
    if (usedSections.includes(item.sectionName)) {
      return;
    }

    usedSections.push(item.sectionName);

    const sectionItems = visibleItems
      .filter((menuItem) => menuItem.sectionName === item.sectionName)
      .sort((a, b) => a.lineNum - b.lineNum);

    result.push({
      title: item.sectionName.toUpperCase(),
      links: sectionItems.map((menuItem) => ({
        text: menuItem.title,
        href: menuItem.slug,
        icon: getSectionIcon(item.sectionName),
      })),
    });
  });

  return result;
};
